// Shadows ember-cli-mirage's auto-start initializer of the same name.
// Mirage is started explicitly from ApplicationRoute instead.
export function initialize() {}

export default {
  name: 'ember-cli-mirage',
  initialize,
};
